import React, { useState } from "react";
import AssetUtils from "../../utils/AssetUtils";
import LoadingSpinner from "../LoadingSpinner";
import styles from "./AsyncPreviewImage.module.css";

/**
 * Renders an async-loaded preview image (e.g. Lottie thumbnails) with a
 * loading spinner overlay and fallback handling.
 *
 * @param {Object} props
 * @param {Object} props.asset - The asset object with key, asset_name, etc.
 * @param {string} [props.alt] - Alt text for the image.
 * @param {"contain"|"cover"} [props.objectFit="contain"] - How the image fits its container.
 */
const AsyncPreviewImage = ({ asset, alt, objectFit = "contain" }) => {
  const [loadedKey, setLoadedKey] = useState(null);
  const [fallbackKey, setFallbackKey] = useState(null);
  const previewLoaded = loadedKey === asset.key;
  const usedFallback = fallbackKey === asset.key;

  const fitClass =
    objectFit === "cover" ? styles["preview-cover"] : styles["preview-contain"];

  return (
    <>
      <img
        className={fitClass}
        src={AssetUtils.getV2PreviewURL(asset.key)}
        alt={alt}
        onLoad={() => setLoadedKey(asset.key)}
        onError={(e) => {
          if (!usedFallback) {
            e.target.src = AssetUtils.getFallbackURL(asset);
            setFallbackKey(asset.key);
          }
          setLoadedKey(asset.key);
        }}
        style={{ opacity: previewLoaded ? 1 : 0 }}
      />
      {!previewLoaded && (
        <div className={styles.loading}>
          <LoadingSpinner />
        </div>
      )}
    </>
  );
};

export default AsyncPreviewImage;
